import { render, staticRenderFns } from "./IssueStageNum.vue?vue&type=template&id=047bf000"
import script from "./IssueStageNum.vue?vue&type=script&lang=js"
export * from "./IssueStageNum.vue?vue&type=script&lang=js"
import style0 from "./IssueStageNum.vue?vue&type=style&index=0&id=047bf000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports